import { render, staticRenderFns } from "./baseOption.vue?vue&type=template&id=80b373e2&scoped=true&"
import script from "./baseOption.vue?vue&type=script&lang=js&"
export * from "./baseOption.vue?vue&type=script&lang=js&"
import style0 from "./baseOption.vue?vue&type=style&index=0&id=80b373e2&lang=scss&scoped=true&"
import style1 from "./baseOption.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b373e2",
  null
  
)

export default component.exports